import * as Yup from "yup";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

export const updateEdition = Yup.object().shape({
  nome: Yup.string()
    .required("O nome da edição é obrigatório")
    .min(3, "O nome deve ter no mínimo 3 letras")
    .max(50, "O nome deve ter no máximo 50 letras"),

  notaCorte: Yup.number()
    .nullable()
    .transform((v, o) => (String(o).trim() === "" ? null : v))
    .min(0, "A nota não pode ser menor que 0.0")
    .max(10, "A nota não pode ser maior que 10.0"),

  agendarInscricoes: Yup.bool(),

  abrirInscricoes: Yup.bool(),

  dataAberturaInscricao: Yup.date()
    .nullable()
    .transform((v, o) => (String(o).trim() === "" ? null : v))
    .when(["agendarInscricoes", "originalDataAbertura"], {
      is: (agendar: boolean, originalData: any) => agendar,
      then: (schema) =>
        schema
          .required("Data e hora de abertura são obrigatórias")
          .typeError("Data de abertura inválida")
          .test(
            "data-alterada-valida",
            "A nova data de abertura deve ser no futuro e com pelo menos 1h de antecedência se for hoje",
            function (value) {
              const { originalDataAbertura } = this.parent;

              if (dayjs(value).isSame(dayjs(originalDataAbertura))) return true;

              if (!value) return false;

              const now = dayjs();
              const sel = dayjs(value);

              if (sel.isBefore(now)) return false;

              if (sel.isSame(now, "day") && sel.isBefore(now.add(1, "hour"))) {
                return false;
              }

              return true;
            }
          ),
      otherwise: (schema) => schema.nullable(),
    }),

  dataFimInscricao: Yup.date()
    .nullable()
    .transform((v, o) => (String(o).trim() === "" ? null : v))
    .when(["agendarInscricoes", "originalDataFim"], {
      is: (agendar: boolean) => agendar,
      then: (schema) =>
        schema
          .required("Data e hora de fechamento são obrigatórias")
          .typeError("Data de fechamento inválida")
          .test(
            "data-fim-maior-que-inicio",
            "A data de fim deve ser posterior à de início",
            function (value) {
              const { dataAberturaInscricao } = this.parent;
              if (!value || !dataAberturaInscricao) return false;
              return dayjs(value).isAfter(dayjs(dataAberturaInscricao));
            }
          ),
      otherwise: (schema) => schema.nullable(),
    }),
});
